import { jsx, Fragment } from 'react/jsx-runtime';
import { Fragment as Fragment$1 } from 'react';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
/**
 * 라디오 버튼 그룹을 구성하는 컴포넌트입니다.
 *
 * @param {Object} props
 * @param {RadioItemProps[]} props.data - 라디오 버튼 아이템들의 데이터 배열 ({label, value, description, onChange, className, RadioClassName}[])
 * @param {string} props.name - 라디오 그룹의 name 속성
 * @param {string} props.selectedValue - 현재 선택된 라디오 버튼의 값
 * @param {Function} props.onChange - 라디오 버튼 선택 변경 시 호출되는 핸들러 함수
 * @param {Function} props.children - 각 라디오 버튼 아이템을 렌더링하는 렌더 프롭 함수
 * @param {boolean} [props.isError] - 에러 상태 여부
 * @param {boolean} [props.isDisabled] - 비활성화 상태 여부
 *
 * @example
 * ```tsx
 * const radioItems = [
 *   { label: '옵션 1', value: '1', description: '첫 번째 옵션입니다.' },
 *   { label: '옵션 2', value: '2', description: '두 번째 옵션입니다.' }
 * ];
 *
 * <RadioGroup
 *   data={radioItems}
 *   name="options"
 *   selectedValue="1"
 *   onChange={(e) => console.log(e.target.value)}
 * >
 *   {(item) => (
 *     <RadioButton
 *       label={item.label}
 *       value={item.value}
 *       description={item.description}
 *       isSelected={item.isSelected}
 *       onChange={item.onChange}
 *     />
 *   )}
 * </RadioGroup>
 * ```
 */ const RadioGroup = ({ data, selectedValue, children, onChange, isError, isDisabled })=>{
    return /*#__PURE__*/ jsx(Fragment, {
        children: data.map((item)=>{
            const isSelected = selectedValue === item.value;
            return /*#__PURE__*/ jsx(Fragment$1, {
                children: children(_object_spread_props(_object_spread({}, item), {
                    onChange,
                    isError,
                    isDisabled,
                    isSelected
                }))
            }, item.value);
        })
    });
};

export { RadioGroup as default };
